import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipIcon',
  props: {
    icon: { default: "mdi-alert" },
    size: { default: "small" },
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_ctx.text)
    ? (_openBlock(), _createBlock(_component_v_tooltip, {
        key: 0,
        location: "bottom"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_icon, _mergeProps({
            class: _ctx.$attrs.class
          }, props, { size: _ctx.size }), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.icon), 1)
            ]),
            _: 2
          }, 1040, ["class", "size"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.text), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})